import {} from '@rocicorp/zero';
import { zql } from '../../schema.js';
// Movements that only bring a batch into stock or adjust it; any other movement means it reached a patient (CY-371).
export const NON_USAGE_MOVEMENT_TYPES = [
    'received',
    'corrected',
    'transferred',
];
export const BATCH_IN_USE_ERROR = 'batch_in_use';
export const BATCH_NOTHING_TO_DISCARD_ERROR = 'batch_nothing_to_discard';
export const BATCH_DISCARDED_ERROR = 'batch_discarded';
/** A disposed (expired and acknowledged) or discarded batch is final; only a discard sets it inactive. */
export function assertBatchEditable(batch) {
    if (batch.acknowledgedAt)
        throw new Error('Cannot edit a disposed batch');
    if (batch.status === 'inactive')
        throw new Error(BATCH_DISCARDED_ERROR);
}
const LOCKED_BATCH_FIELDS = ['tradeNameId', 'consumableId', 'lotNumber', 'expiryDate'];
/** The product, lot and expiry fields an update would change; an omitted field is left as it is. */
export function getLockedBatchFieldChanges(prev, next) {
    return LOCKED_BATCH_FIELDS.filter(field => {
        const value = next[field];
        if (value === undefined)
            return false;
        return (value ?? null) !== (prev[field] ?? null);
    });
}
/** The signed movement quantity that takes the remaining stock of a batch out. */
export function getDiscardQuantity(quantity) {
    const remaining = Number(quantity ?? 0);
    if (!(remaining > 0))
        throw new Error(BATCH_NOTHING_TO_DISCARD_ERROR);
    return -remaining;
}
/** A batch is used once it moved towards a patient or sits on a picking list. */
export async function isBatchUsed(tx, batchId) {
    const [movement, orderLink] = await Promise.all([
        tx.run(batchUsageMovementQuery(batchId)),
        tx.run(batchOrderLinkQuery(batchId)),
    ]);
    return Boolean(movement || orderLink);
}
export function batchUsageMovementQuery(batchId) {
    return zql.stockMovements
        .where('batchId', '=', batchId)
        .where('type', 'NOT IN', [...NON_USAGE_MOVEMENT_TYPES])
        .where('deletedAt', 'IS', null)
        .one();
}
export function batchOrderLinkQuery(batchId) {
    return zql.orderBatches.where('batchId', '=', batchId).where('deletedAt', 'IS', null).one();
}
//# sourceMappingURL=batch-usage.js.map